/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_4_steps_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose one sample: budget for amounts, grades for formulas, or sales for charts and summaries.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_4_steps_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个示例：预算用于金额，成绩用于公式，销售用于图表和汇总。`)
};

/**
* | output |
* | --- |
* | "Choose one sample: budget for amounts, grades for formulas, or sales for charts and summaries." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_4_steps_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_4_steps_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_4_steps_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_4_steps_0 as "gc.search_guides.what_is_gridcraft.sections.4.steps.0" }